import validateMany from "services/redux-form/validateMany";
import regex from "services/regex";

const validate = (values) => {
  let _errors = {};
  const settingPassword = JSON.parse(localStorage.getItem("settingPassword"));

  let required = ["oldPassword"];

  required.map((r) => {
    if (!values[r]) {
      _errors[r] = app.translate("main.This field is required");
    }
  });


  if (values["newPassword"]) {
    if (values["newPassword"].length < settingPassword.minLength) {
      _errors["newPassword"] = app.translate("main.minCharacters", {
        count: settingPassword.minLength,
      });
    }

    // Check for complex password requirements if enabled
    if (settingPassword.isComplexPassword) {
      const complexityPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/;
      if (!complexityPattern.test(values["newPassword"])) {
        _errors["newPassword"] =
          "رمز عبور باید شامل حروف بزرگ، حروف کوچک، اعداد و نمادها باشد.";
      }
    }
  }

  if (values["newPasswordConfirmation"]) {
    if (values["newPasswordConfirmation"].length < settingPassword.minLength) {
      _errors["newPasswordConfirmation"] = app.translate("main.minCharacters", {
        count: settingPassword.minLength,
      });
    }

    // Check for complex password requirements if enabled
    if (settingPassword.isComplexPassword) {
      const complexityPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/;
      if (!complexityPattern.test(values["newPasswordConfirmation"])) {
        _errors["newPasswordConfirmation"] =
          "رمز عبور باید شامل حروف بزرگ، حروف کوچک، اعداد و نمادها باشد.";
      }
    }
  }

  // Only check password match if both fields have values
  if (
    values["newPassword"] &&
    values["newPasswordConfirmation"] &&
    values["newPassword"] !== values["newPasswordConfirmation"]
  ) {
    _errors["newPasswordConfirmation"] = app.translate(
      "routes.auth.Password doesn't match"
    );
  }

  return _errors;
};

export default validate;
